export default __webpack_public_path__ + "static/media/profile3.f632d677.svg";